// What a person's number is (people-create-door, ruling 2). The server's one
// vocabulary is utils/person-phones.js PHONE_LABELS (migration 04's CHECKs);
// this is its copy for the label pickers, and the server refuses any other word.
// Guard: tests/phf-form-differs-door.test.js V3 (the two lists are equal).
export const PHONE_LABELS = Object.freeze(['mobile', 'home', 'office', 'other']);

// THE OLD MAIN WHEN A MAIN IS REPLACED (Q57, S21, at the flip). mainClass is the
// server's phone_main_class (present only once people is the authority, AR39):
// over a main of a class in KEEPS_OLD_MAIN the server keeps the old number as a
// second number unless David says replace (keep_old_as false), so the blank
// choice reads keep. Without it (zoho mode, another main) the words are today's.
// KEEPS_OLD_MAIN is the server's common.keepsOldMain for a broker write
// (guard: tests/phf-form-differs-door.test.js V4).
export const KEEPS_OLD_MAIN = Object.freeze(['copy', 'rule']);
const REPLACE = 'replace';
export function oldNumberChoices(mainClass) {
  const keeps = KEEPS_OLD_MAIN.includes(mainClass);
  return [
    { value: '', label: keeps ? 'Old number: keep' : 'Old number: replace' },
    ...(keeps ? [{ value: REPLACE, label: 'Old number: replace' }] : []),
    ...PHONE_LABELS.map((l) => ({ value: l, label: `Old number: keep as ${l}` })),
  ];
}
export const keepOldAsBody = (choice) => (choice === REPLACE ? { keep_old_as: false } : choice ? { keep_old_as: choice } : {});
